import React from 'react';
import styled from 'styled-components';

const SearchParamsControl = (props) => {
  const { children, innerProps, innerRef } = props;
  return (
    <StyledButton ref={innerRef} {...innerProps} {...props}>
      {children}
    </StyledButton>
  );
};

const StyledButton = styled.div`
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

export default SearchParamsControl;
